import React from 'react';
import { useHistory } from 'react-router-dom';

import './mobile-custom-header.scss';

import BackButton from '@src/componentsNew/Buttons/BackButton';
import Typography from '@src/componentsNew/Typography/Typography';
import HomeIcon from '@src/componentsNew/Icons/Icons/HomeIcon';

import { baseUrl } from '@src/app/routes';
import { TypographyVariant, TypographyComponent } from '@src/utils/types';

interface IProps {
  type?: 'center' | 'left';
  isShowBackBtn?: boolean;
  isShowHomeBtn?: boolean;
  backBtnColor?: string;
  onBackBtnClick?: any;
  pageTitle?: string;
  pageTitleColor?: string;
  pageTitleVariant?: TypographyVariant;
  pageTitleComponent?: TypographyComponent;
  onPageTitleClick?: any;
  rightChild?: any;
}

const MobileCustomHeader = ({
  type,
  isShowBackBtn,
  isShowHomeBtn,
  backBtnColor,
  onBackBtnClick,
  pageTitle,
  pageTitleColor,
  pageTitleVariant,
  pageTitleComponent,
  onPageTitleClick,
  rightChild,
}: IProps) => {
  const history = useHistory();

  return (
    <div id="mobile-custom-header" className={type}>
      {(isShowBackBtn || isShowHomeBtn) && (
        <div className="left-child">
          {isShowBackBtn && (
            <BackButton
              style={{ color: backBtnColor ? backBtnColor : '#1C232C70' }}
              onClick={() => (onBackBtnClick ? onBackBtnClick() : history.goBack())}
            />
          )}

          {isShowHomeBtn && <HomeIcon fillColor={'#222222'} onClick={() => history.push(baseUrl)} />}
        </div>
      )}

      {pageTitle && (
        <Typography
          variant={pageTitleVariant ? pageTitleVariant : 'h7'}
          component={pageTitleComponent ? pageTitleComponent : 'h3'}
          style={{ color: pageTitleColor ? pageTitleColor : '#212121' }}
          onClick={onPageTitleClick}
          cName="page-title"
        >
          {pageTitle}
        </Typography>
      )}

      {rightChild && <div className="right-child">{rightChild}</div>}
    </div>
  );
};

export default MobileCustomHeader;
